import React from 'react';
import { motion } from 'framer-motion';
import { Users, Laptop, BookOpen, ArrowRight, UserPlus, Zap, Award } from 'lucide-react';

// Importe a imagem do logo da Next Devs Academy
import logoND from '../../assets/next-devs-com-frase.jpg';

const NextDevsAcademy: React.FC = () => {
  return (
    <section id='community' className="relative py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-blue-900/20 to-black" />
      
      <div className="container mx-auto px-4 relative">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center mb-16"
        >
          <motion.span 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/20 text-blue-400 text-sm mb-4"
            whileHover={{ scale: 1.05 }}
          >
            <Zap className="w-5 h-5" />
            <span>Comunidade em Crescimento</span>
          </motion.span>
          
          <h2 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600 mb-6">
            NEXT DEVS ACADEMY
          </h2>
          <p className="text-blue-200 text-xl max-w-2xl mx-auto">
            Junte-se a uma comunidade vibrante de mais de 600 alunos apaixonados por tecnologia e desenvolvimento.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <motion.img
              src={logoND}
              alt="NEXT DEVS ACADEMY"
              className="w-full h-[50rem] object-cover rounded-xl shadow-2xl"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-3xl font-bold text-blue-300">
              Desenvolva suas habilidades conosco
            </h3>
            <p className="text-blue-200 text-lg">
              Na NEXT DEVS ACADEMY, oferecemos uma experiência de aprendizado única, combinando teoria e prática para formar os melhores desenvolvedores do mercado.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center gap-3 bg-blue-900/30 p-4 rounded-lg">
                <Users className="w-8 h-8 text-blue-400" />
                <div>
                  <div className="text-2xl font-bold text-blue-300">600+</div>
                  <div className="text-blue-200 text-sm">Alunos Ativos</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-blue-900/30 p-4 rounded-lg">
                <Laptop className="w-8 h-8 text-blue-400" />
                <div>
                  <div className="text-2xl font-bold text-blue-300">20+</div>
                  <div className="text-blue-200 text-sm">Cursos Práticos</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-blue-900/30 p-4 rounded-lg">
                <BookOpen className="w-8 h-8 text-blue-400" />
                <div>
                  <div className="text-2xl font-bold text-blue-300">1-on-1</div>
                  <div className="text-blue-200 text-sm">Mentoria Personalizada</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-blue-900/30 p-4 rounded-lg">
                <Award className="w-8 h-8 text-blue-400" />
                <div>
                  <div className="text-2xl font-bold text-blue-300">95%</div>
                  <div className="text-blue-200 text-sm">Taxa de Satisfação</div>
                </div>
              </div>
            </div>
            <motion.a
              href="https://chat.whatsapp.com/Et1v8rhOw7hH85OXlwkAwg"
              
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 text-white font-medium rounded-full transition-all duration-300 hover:bg-green-600 hover:shadow-lg hover:shadow-green-500/20 group"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <UserPlus className="w-5 h-5" />
              <span>Entrar no Grupo do WhatsApp</span>
              <span className="text-xs ml-1">(100% Gratuito)</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NextDevsAcademy;